import React, { useEffect, useState } from "react";
import "./Portfolio.css";
import AOS from "aos";
import "aos/dist/aos.css";
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { BASE_URL } from "../../config/baseUrl";

const Portfolio = () => {
  const [images, setImages] = useState([]);
  const fallbackImage = `${process.env.PUBLIC_URL}/assets/img/gallery/fallback.jpg`;

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const fetchGallery = async () => {
      try {
        
        const res = await fetch(`${BASE_URL}/Gallery/list`);

        if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
        const data = await res.json();

        if (Array.isArray(data)) setImages(data.slice(0, 6));
        else console.error("Unexpected gallery data:", data);
      } catch (err) {
        console.error("Error fetching gallery images:", err);
      }
    };

    fetchGallery();

    const lightbox = GLightbox({ selector: ".glightbox" });
    return () => lightbox.destroy();
  }, []);

  // ✅ Helper for handling absolute/relative URLs
  const getImageUrl = (imgPath) => {
    if (!imgPath) return fallbackImage;
    if (imgPath.startsWith("https")) return imgPath;
    return `https://localhost:5000/${imgPath.replace(/\\/g, "/")}`;
  };

  return (
    <section id="portfolio" className="portfolio section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Portfolio</h2>
        <p>A quick glimpse of moments and work. Explore the full gallery for more.</p>
      </div>

      <div className="container">
        <div className="row gy-4 mt-4" data-aos="fade-up" data-aos-delay="100">
          {images.map((img, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12">
              <div className="portfolio-content h-100">
                <div className="ratio ratio-16x9">
                  <img
                    src={getImageUrl(img)}
                    className="img-fluid object-fit-cover rounded"
                    alt={`Gallery item ${index + 1}`}
                    loading="lazy"
                    onError={(e) => (e.target.src = fallbackImage)}
                  />
                </div>
                <div className="portfolio-info">
                  <a
                    href={getImageUrl(img)}
                    title={`Gallery ${index + 1}`}
                    data-gallery="gallery-preview"
                    className="glightbox preview-link"
                    aria-label={`Preview Gallery ${index + 1}`}
                  >
                    <i className="bi bi-zoom-in"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-4">
          <Link to="/gallery" className="btn-get-started">
            View Full Gallery
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
